import React from "react";
import { useParams } from "react-router-dom";

const TeamTrades = () => {
  const { league, season, team } = useParams();

  return (
    <div>
      Team Trades
      <p>
        {league} {season} {team} trades
      </p>
    </div>
  );
};

export default TeamTrades;
